import { UseQueryOptions } from '@tanstack/react-query';
import { CuredApiPaths } from 'models/enums';
import useQuery from '../useQuery';
import QueryKeys from './keys';

export type RowDisplayCondition = {
    id: number;
    label: string;
    description: string;
    before: string;
    after: string;
    type: string;
};

const useRowDisplayConditions = (reactQueryOptions?: UseQueryOptions<RowDisplayCondition[], Error>) =>
    useQuery<RowDisplayCondition[]>(
        QueryKeys.ROW_DISPLAY_CONDITIONS,
        `${CuredApiPaths.ROW_DISPLAY_CONDITIONS}`,
        reactQueryOptions
    );

export default useRowDisplayConditions;
